/**
 * The directory shape: which refs a viewer may see by name. Pure - the read
 * layer fills it (src/read/directory.ts, viewer-scoped), the UI resolves
 * through it (src/lib/directory.ts). Display names only. `deleted` marks a
 * person whose account is deleted (docs/MODEL.md §6b): the name still
 * resolves, and no picker offers the ref (`pickableRefs`). `scrubbed` marks
 * one whose personal data is gone too: the name it carries is the stored
 * English placeholder, which `withPlaceholders` (src/lib/directory.ts)
 * replaces with the reader's word.
 */
export type Directory = Readonly<Record<string, { name: string; deleted?: true; scrubbed?: true }>>;

/**
 * The key under which a directory carries the name a ref of one kind wears when
 * the directory cannot resolve it (`withPlaceholders`, src/lib/directory.ts),
 * in the reader's language. `?` never starts a ref (`<kind>:<id>`), so a
 * placeholder key collides with no ref, and the walk over the refs
 * (`pickableRefs`) skips it.
 */
export function placeholderKey(kind: 'person' | 'group' | 'automation'): string {
  return `?${kind}`;
}
